// State-based reset content for Pro users.
// 5 states: calm, neutral, anxious, overwhelmed, low_energy
// Each state has tailored breathwork, reframes, journal prompts, affirmations.
// Free users get the "neutral" content as the universal route.

export const STATES = [
  { id: "calm", label: "Calm", emoji: "🌿", description: "Steady, settled, at ease" },
  { id: "neutral", label: "Neutral", emoji: "⚖️", description: "Even, neither up nor down" },
  { id: "anxious", label: "Anxious", emoji: "🌊", description: "Racing thoughts, tight chest" },
  { id: "overwhelmed", label: "Overwhelmed", emoji: "🌪️", description: "Too much at once" },
  { id: "low_energy", label: "Low Energy", emoji: "🍃", description: "Heavy, slow, depleted" },
];

export const STATE_RESETS = {
  calm: {
    breathwork: { name: "Coherent Breath", pattern: [5, 0, 5, 0], cycles: 6, instruction: "Inhale 5 · Exhale 5" },
    mindset: "Calm is not the absence of life. It is the room I make for what comes next.",
    journalIn: "What in me feels settled right now?",
    journalOut: "How can I bring this steadiness into one task today?",
    affirmation: "I carry this calm forward, gently.",
  },
  neutral: {
    breathwork: { name: "Box Breath", pattern: [4, 4, 4, 4], cycles: 4, instruction: "Inhale 4 · Hold 4 · Exhale 4 · Hold 4" },
    mindset: "Neutral is a doorway, not a destination. I get to choose which way I walk through.",
    journalIn: "What is the truest thing I can say about today, so far?",
    journalOut: "What is one tiny next step that feels right?",
    affirmation: "I meet today as it is, and I begin.",
  },
  anxious: {
    breathwork: { name: "Long Exhale", pattern: [4, 0, 8, 0], cycles: 5, instruction: "Inhale 4 · Exhale 8" },
    mindset: "Anxiety is a story about a future that has not arrived. I return to the room.",
    journalIn: "Name 5 things I can see, 4 I can touch, 3 I can hear.",
    journalOut: "What truth do I know right now that the worry is ignoring?",
    affirmation: "The ground is here. I am here. That is enough.",
  },
  overwhelmed: {
    breathwork: { name: "4-7-8 Breath", pattern: [4, 7, 8, 0], cycles: 4, instruction: "Inhale 4 · Hold 7 · Exhale 8" },
    mindset: "I cannot do all of it. I can do the next one thing. That is allowed to be enough.",
    journalIn: "Of everything in my head, what is the loudest? Name it.",
    journalOut: "What is the smallest version of the next step?",
    affirmation: "I lay down the pile. I pick up the next stone.",
  },
  low_energy: {
    breathwork: { name: "Energizing Breath", pattern: [3, 0, 3, 0], cycles: 8, instruction: "Quick inhale 3 · Quick exhale 3" },
    mindset: "Rest is not a failure of will. It is part of the work.",
    journalIn: "Where is the energy actually going right now?",
    journalOut: "What can I subtract today, instead of add?",
    affirmation: "I do less, but I do it with care.",
  },
};

// Universal / free reset is the "neutral" state.
export function getUniversalReset() {
  return { id: 0, category: "Universal", ...STATE_RESETS.neutral };
}

export function getResetForState(stateId) {
  if (!stateId || !STATE_RESETS[stateId]) return getUniversalReset();
  const s = STATES.find((x) => x.id === stateId);
  return { id: STATES.findIndex((x) => x.id === stateId) + 1, category: s?.label || "Universal", ...STATE_RESETS[stateId] };
}
